export default [

    {
        path: '',
        name: 'midias-sociais',
        redirect: { name: 'midias-sociais-home' },
    },

    {
        path: 'home',
        name: 'midias-sociais-home',
        component: () => import('@/aplicacao/modulos/midias-sociais/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL' },
    },

    {
        path: 'historico',
        name: 'midias-sociais-historico',
        component: () => import('@/aplicacao/modulos/midias-sociais/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL' },
    },

    {
        path: 'pendencias',
        name: 'midias-sociais-pendencias',
        component: () => import('@/aplicacao/modulos/midias-sociais/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'midias-sociais-rascunhos',
        component: () => import('@/aplicacao/modulos/midias-sociais/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL_SOLICITAR' },
    },

    {
        path: 'formulario/:id?',
        name: 'midias-sociais-formulario',
        component: () => import('@/aplicacao/modulos/midias-sociais/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'midias-sociais-fluxo',
        component: () => import('@/aplicacao/modulos/midias-sociais/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_MIDIA_SOCIAL' },
    },

]
